module.exports = __webpack_public_path__ + "img/neck opening.37cf39e2.png";